import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"cardBorderStyle",attrs:{"flat":""}},[_c('div',{ref:"chart"}),_c(VCardTitle,{staticClass:"d-flex align-center justify-center"},[_vm._v("E-file Analytics")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }